import _taggedTemplateLiteral from "/codebuild/output/src196865849/src/github.com/EverlyWell/www/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  padding-bottom: ", "px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border-bottom: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from "styled-components";
import { colors, size } from "../../../shared/constants";
export var ChildWrapper = styled.div.attrs(function (o) {
  return {
    showBorderBottom: o.showBorderBottom
  };
})(_templateObject(), function (_ref) {
  var o = _ref.showBorderBottom;
  return o && "1px solid " + colors.gray2;
});
export var ContentWrapper = styled.div(_templateObject2(), size.xl4);